module.exports = __webpack_public_path__ + "src/assets/img/music-icon.618e8751.png";